import React from "react";
import { UserCheck } from "lucide-react";

const UserLogo = ({ size = 18, className = "" }) => {
  return <UserCheck size={size} className={className} />;
};

export default UserLogo;
